import { Button, CameraIcon, Card, css, Heading, Inline, Paragraph, Stack, styled } from 'canoe';
import React from 'react';
import { EXTENSION_LINK } from 'site-constants';

import EmptyPlacementsImg from '!!react-svg-loader!./assets/empty-snapshot-placements.svg';
import { useToggle } from 'commons/hooks';

import { AddSnapshotModal } from './AddSnapshotModal';

const manualPlacementGuide =
  'https://docs.candu.ai/en/articles/5916841-launching-candu-content#h_1fe03a45a1';
const extensionPlacementGuide =
  'https://docs.candu.ai/en/articles/5916841-launching-candu-content#h_b763342841';

interface EmptyPlacementInstructionsProps {
  contentId: string;
  showGrabSnapshot?: boolean;
}

const Link = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors.BrandPurple};
  `}
`;

const PlacementsContainer = styled(Card)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spaces.l};
  `}
`;

const AddSnapshotCard = styled.div`
  ${({ theme }) => css`
    min-width: 670px;
    border: 1px solid ${theme.colors.GlitterGray};
    border-radius: ${theme.borderRadius.small};
    padding: 0 0 0 ${theme.spaces.l};
    margin-bottom: ${theme.spaces.xl};
  `}
`;

export const EmptyPlacementInstructions = ({
  contentId,
  showGrabSnapshot,
}: EmptyPlacementInstructionsProps) => {
  const [addSnapshotModalOpen, toggleAddSnapshotModalOpen] = useToggle();

  if (showGrabSnapshot) {
    return (
      <AddSnapshotCard>
        <Inline space="s" align="center" justify="space-between" wrap="nowrap">
          <Stack space="s">
            <Paragraph size="short" maxWidth="none" color="OnyxGrayL10">
              Editing Content and adding Placements is so much easier with Snapshots. Why not give
              it a try?
            </Paragraph>
            <Button
              onClick={toggleAddSnapshotModalOpen}
              variant="secondary"
              appearance="outline"
              icon={CameraIcon}
            >
              Grab snapshot of your product
            </Button>
          </Stack>
          <EmptyPlacementsImg />
        </Inline>
        {addSnapshotModalOpen && (
          <AddSnapshotModal onClose={toggleAddSnapshotModalOpen} contentId={contentId} forceOpen />
        )}
      </AddSnapshotCard>
    );
  }

  return (
    <PlacementsContainer elevation="+1">
      <Stack justify="center" space="xs">
        <Heading size="XS">You haven’t placed this content anywhere yet.</Heading>
        <Paragraph maxWidth="none">
          We recommend using the{' '}
          <Link href={EXTENSION_LINK} target="_blank">
            Candu Chrome Extension
          </Link>{' '}
          to preview and embed your content. View guide{' '}
          <Link href={extensionPlacementGuide} target="_blank">
            here
          </Link>
          .
        </Paragraph>
        <Paragraph maxWidth="none">
          Alternatively, you can embed content directly from this page. View guide{' '}
          <Link href={manualPlacementGuide} target="_blank">
            here
          </Link>
          .
        </Paragraph>
        <Paragraph maxWidth="none">
          Please note: All content must be ‘Published’ first using the button in the top-right
          corner of the screen.
        </Paragraph>
      </Stack>
    </PlacementsContainer>
  );
};
